var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useFilespaceListByWorkspaceId } from '#query-hooks';
import { filespaceRoutes, workspaceRoutes } from '#services';
export const FilespacePermissionRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const navigate = useNavigate();
    const [hasPermissions, setHasPermissions] = useState(null);
    const filespaceWithPermission = useRef(null);
    const { query: { data: allFilespacesData, isError: isErrorFilespaces }, } = useFilespaceListByWorkspaceId(workspaceId);
    const currentFilespace = useMemo(() => {
        return (allFilespacesData?.find((fsData) => fsData.id === filespaceId) ||
            null);
    }, [allFilespacesData, filespaceId]);
    useEffect(() => {
        // Listen if the filespace permissions have been revoked or set
        if (isErrorFilespaces || (allFilespacesData && !currentFilespace)) {
            setHasPermissions(false);
        }
        if (currentFilespace) {
            setHasPermissions(true);
        }
    }, [
        currentFilespace,
        isErrorFilespaces,
        navigate,
        workspaceId,
        allFilespacesData,
    ]);
    if (hasPermissions === null) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Loading filespace data'), "data-testid": "filespace-data", isFullHeight: true }) }));
    }
    else if (hasPermissions && currentFilespace) {
        filespaceWithPermission.current = currentFilespace;
        return children;
    }
    else {
        const upgradedFilespace = allFilespacesData?.find((fs) => fs.name === filespaceWithPermission.current?.name &&
            fs.workspaceId ===
                filespaceWithPermission.current?.workspaceId &&
            fs.id !== filespaceWithPermission.current?.id);
        if (upgradedFilespace) {
            return (_jsx(Navigate, { to: filespaceRoutes.filespaceDashboard({
                    filespaceId: upgradedFilespace.id,
                    workspaceId: upgradedFilespace.workspaceId,
                }) }));
        }
        filespaceWithPermission.current = null;
        return _jsx(Navigate, { to: workspaceRoutes.workspace(workspaceId) });
    }
};
_react_refresh_temp_1 = FilespacePermissionRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "FilespacePermissionRouteGuard");
_react_refresh_temp_2(FilespacePermissionRouteGuard, "Fvr+yf+9WRgnSZORR98i8+sYWr8=", false, () => [useParams, useNavigate, useFilespaceListByWorkspaceId]);
